import type { CodesDetail } from '@/api/model/basicTypes'

export interface State {
  current_page: number
  total_count: number
  detail: Array<any>
  carts_count: number
  params: Params
  receive_count: number
  send_count: number
  folderChangeModalStatus: boolean
  transactionStatusInfo: CodesDetail
  transactionStatus: string
  choosed_detail: Array<any>
}

export interface Params {
  sender_recipient_flag: string
  product_id: string
  transaction_display_category: string
  sender_corporate_name: string
  sender_product_name: string
  received_date_start: string
  received_date_end: string
  owner_product_code: string
  owner_product_name: string
  recipient_client_code: string
  recipient_corporate_name: string
  sent_date_start: string
  sent_date_end: string
  sort_column: string
  sort: string
  page_size: number
  page_number: number
  transaction_status: number
  sender_user_name: string
  recipient_user_name: string
}

const state = (): State => ({
  current_page: 0,
  total_count: 0,
  detail: [],
  carts_count: 0,
  receive_count: 0,
  send_count: 0,
  params: {
    sender_recipient_flag: '0',
    product_id: '',
    transaction_display_category: '',
    sender_corporate_name: '',
    sender_product_name: '',
    received_date_start: '',
    received_date_end: '',
    owner_product_code: '',
    owner_product_name: '',
    recipient_client_code: '',
    recipient_corporate_name: '',
    sent_date_start: '',
    sent_date_end: '',
    sort_column: 'sent_date',
    sort: 'DESC',
    page_size: 20,
    page_number: 1,
    transaction_status: -1,
    sender_user_name: '',
    recipient_user_name: '',
  },
  folderChangeModalStatus: false,
  transactionStatusInfo: {} as CodesDetail,
  transactionStatus: '',
  choosed_detail: [],
})

export default state
